import { Link } from "react-router-dom";
import { MarketingChrome } from "../components/MarketingChrome";
import {
  IconArrow,
  IconCheck,
  IconList,
  IconMail,
  IconMic,
  IconSearch,
  IconShield,
  IconUser,
  IconWallet,
} from "../components/Icons";

const STEPS = [
  ["Apply", "APPLICATION", "Tell us your basic details.", IconUser],
  ["Record your sample", "APPLICATION", "Submit a short natural voice recording.", IconMic],
  ["We review it", "APPLICATION", "Our team checks the sample for clarity and suitability.", IconSearch],
  ["Receive your invitation", "APPLICATION", "Selected contributors receive an email invitation.", IconMail],
  ["Create your account", "CONTRIBUTOR", "Use the same email address and your invitation code.", IconCheck],
  ["Choose available prompts", "CONTRIBUTOR", "You'll see eligible recording opportunities.", IconList],
  ["Record and submit", "CONTRIBUTOR", "Respond naturally using your own voice.", IconMic],
  ["Review", "CONTRIBUTOR", "Inputry reviews your contribution.", IconShield],
  ["Get paid", "CONTRIBUTOR", "Approved recordings earn the applicable rate and are paid through PayPal/Wise", IconWallet],
] as const;

export function HowItWorks() {
  return (
    <MarketingChrome back={{ to: "/", label: "Back to Inputry" }}>
      <div className="narrow-page how-it-works-page" style={{ maxWidth: 760 }}>
        <div className="kicker"><i /> How it works</div>
        <h1 className="page-title-xl">
          From application to <span className="accent-text">your first paid contribution</span>
        </h1>
        <p className="sub">Here's what happens when you apply to join the Inputry contributor network.</p>
        <div className="timeline">
          {STEPS.map(([title, tag, copy, Icon], index) => (
            <>
              <article key={title} className="timeline-item">
                <div className="step-num">{String(index + 1).padStart(2, "0")}</div>
                <div className="soft-card">
                  <div style={{ marginTop: 0 }} className="soft-card-content">
                    <div className="soft-icon">
                      <Icon width={16} height={16} />
                    </div>
                    <div className="soft-icon-text">
                        <div className="soft-card-title">
                          <h3>{title}</h3>
                          <span className="tag">{tag}</span>
                        </div>
                        <p>{copy}</p>
                    </div>
                  </div>
                </div>
              </article>
            </>
          ))}
        </div>
        <section className="closing">
          <h2>Ready to add your voice?</h2>
          <p className="legal-copy" style={{ marginBottom: 16 }}>Apply and submit a short voice sample.</p>
          <Link to="/apply" className="btn btn-primary">
            Apply to contribute <IconArrow width={16} height={16} />
          </Link>
          <p className="fine">
            Already invited? <Link to="/signup">Create your account</Link>
          </p>
        </section>
      </div>
    </MarketingChrome>
  );
}
